// extracted by mini-css-extract-plugin
module.exports = {"termsWrapper":"_3Z-Ks","termsCondition":"_3Po2-"};